import type { Gender } from "../api/types";

/** Pilihan jenis kelamin untuk dropdown (form pendaftaran & profil pasien). */
export const GENDER_OPTIONS: Array<{ value: Gender; label: string }> = [
  { value: "L", label: "Laki-laki" },
  { value: "P", label: "Perempuan" },
];

/** Label & badge kecil gender terapis ("L" = laki-laki, "P" = perempuan). */
export function genderLabel(gender: string | null | undefined): string | null {
  if (gender === "L") return "Terapis laki-laki";
  if (gender === "P") return "Terapis perempuan";
  return null;
}

export function GenderTag({ gender }: { gender: string | null | undefined }) {
  const label = genderLabel(gender);
  if (!label) return null;
  return (
    <span
      className="gender-tag"
      role="note"
      title={label}
      style={{ whiteSpace: "nowrap" }}
    >
      {gender === "L" ? "♂ Laki-laki" : "♀ Perempuan"}
    </span>
  );
}
